import { documentReady } from "@sazka/utils/document-ready";
import { debounce } from "@sazka/utils/debounce";
import { LotteryCountdownManager } from "@/lotteries/components/lottery-countdown-manager";

documentReady(() => {
    LotteryCountdownManager.instance = new LotteryCountdownManager();

    const body = document.body;
    const heroBanner = document.querySelector(".lp-hero");
    const transparentClass = document.querySelectorAll(".lp-hero-redesign--transparent");
    const heroSolid = document.querySelector(".lp-hero-redesign__solid");
    const header = document.getElementById("header");
    const buttonMain = document.getElementById("lp-hero-redesign-button-main");
    const buttonSticky = document.getElementById("lp-hero-redesign-button-sticky");
    const classNameForStickyEnabled = "lp-hero-redesign__button-sticky--on";
    const playButton = document.querySelector<HTMLButtonElement>('[data-js-hook="hero-play-btn"]');
    const videoDesktop = document.querySelector<HTMLVideoElement>("video.lp-hero-video--desktop");
    const videoTablet = document.querySelector<HTMLVideoElement>("video.lp-hero-video--tablet");
    const videoMobile = document.querySelector<HTMLVideoElement>("video.lp-hero-video--mobile");

    if (transparentClass.length > 0 && heroSolid && header) {
        const heroSolidStyle = heroSolid.getAttribute("style");
        if (heroSolidStyle && heroSolidStyle.indexOf("#") > -1) {
            header.setAttribute("style", heroSolidStyle);
        }
        header.classList.add("header--hero");
    }

    window.addEventListener(
        "resize",
        debounce(() => {
            if (window.matchMedia("(min-width: 2500px)").matches && transparentClass.length > 0) {
                heroBanner?.classList.add("has-overlay");
            }
        }, 50),
        { passive: true }
    );

    if (buttonSticky && buttonMain) {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting && window.matchMedia("(max-width: 767px)").matches) {
                    buttonSticky.classList.add(classNameForStickyEnabled);
                } else {
                    buttonSticky.classList.remove(classNameForStickyEnabled);
                }
            });
        });
        observer.observe(buttonMain);
    }

    if (body.classList.contains("safari") && ("ontouchstart" in window || navigator.maxTouchPoints > 0)) {
        playButton?.classList.add("d-none");
    }

    const isVideoPlaying = (video: HTMLVideoElement | null): boolean =>
        !!(video && video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2);

    const setupSound = (video: HTMLVideoElement | null) => {
        if (video) {
            video.onended = () => {
                video.play();
                video.muted = true;
            };
        }
    };

    const setupVideos = () => {
        if (window.innerWidth < 960) {
            videoMobile?.play();
            videoTablet?.pause();
            videoDesktop?.pause();
            setupSound(videoMobile);
        } else if (window.innerWidth >= 960 && window.innerWidth < 1280) {
            videoMobile?.pause();
            videoTablet?.play();
            videoDesktop?.pause();
            setupSound(videoTablet);
        } else {
            videoMobile?.pause();
            videoTablet?.pause();
            videoDesktop?.play();
            setupSound(videoDesktop);
        }
    };

    const handlePlayButton = () => {
        playButton?.classList.add("is-hidden");
        setupVideos();
    };

    playButton?.addEventListener("click", handlePlayButton);

    window.addEventListener(
        "resize",
        debounce(() => {
            if (isVideoPlaying(videoMobile) || isVideoPlaying(videoTablet) || isVideoPlaying(videoDesktop)) {
                setupVideos();
            }
        }, 10),
        { passive: true }
    );

    setupVideos();
});
